import { object, SchemaOf, string } from 'yup'
import i18n from 'i18next'

interface BaseBootstrapSchema {
  email: string
  password: string
}

export const validationSchemaAuth: SchemaOf<BaseBootstrapSchema> = object({
  email: string()
    .email(i18n.t('createCampaignPage.invalidEmailAddress'))
    .required(i18n.t('createCampaignPage.pleaseEnterTheRequiredField')),

  password: string().required(
    i18n.t('createCampaignPage.pleaseEnterTheRequiredField')
  ),
})

export const reviewTrackSchema = (blacklistWords: Array<string>) =>
  object().shape({
    reviewText: string()
      .test(
        'len',
        i18n.t('reviewsPage.commentTooShort'),
        // @ts-ignore
        value => value?.replace(/\s/g, '').length > 70
      )
      .test('blacklist', i18n.t('reviewsPage.blacklistError'), value => {
        // @ts-ignore
        let result
        const userWords = value?.toLowerCase()?.split(' ')
        userWords?.forEach(text => {
          // @ts-ignore
          if (result) {
            return null
          }
          result = blacklistWords.includes(text)
          return null
        })
        return !result
      }),
  })

export const arrPhoneCodes = [
  '+35818',
  '+1876',
  '+1869',
  '+1868',
  '+1809',
  '+1784',
  '+1684',
  '+1284',
  '+1767',
  '+1758',
  '+1473',
  '+1268',
  '+1264',
  '+1246',
  '+1242',
  '+297',
  '+298',
  '+998',
  '+996',
  '+995',
  '+994',
  '+993',
  '+992',
  '+986',
  '+977',
  '+976',
  '+975',
  '+974',
  '+973',
  '+972',
  '+971',
  '+968',
  '+967',
  '+966',
  '+965',
  '+964',
  '+963',
  '+962',
  '+961',
  '+960',
  '+880',
  '+856',
  '+855',
  '+850',
  '+692',
  '+691',
  '+688',
  '+686',
  '+685',
  '+682',
  '+599',
  '+681',
  '+680',
  '+211',
  '+679',
  '+678',
  '+677',
  '+676',
  '+675',
  '+674',
  '+673',
  '+670',
  '+598',
  '+597',
  '+595',
  '+593',
  '+592',
  '+591',
  '+509',
  '+507',
  '+506',
  '+505',
  '+504',
  '+503',
  '+502',
  '+501',
  '+423',
  '+421',
  '+420',
  '+389',
  '+387',
  '+385',
  '+381',
  '+380',
  '+378',
  '+377',
  '+376',
  '+375',
  '+374',
  '+373',
  '+372',
  '+371',
  '+370',
  '+359',
  '+358',
  '+357',
  '+356',
  '+355',
  '+354',
  '+353',
  '+352',
  '+351',
  '+291',
  '+269',
  '+268',
  '+267',
  '+266',
  '+265',
  '+264',
  '+263',
  '+261',
  '+260',
  '+259',
  '+257',
  '+256',
  '+255',
  '+254',
  '+253',
  '+252',
  '+251',
  '+250',
  '+249',
  '+248',
  '+245',
  '+244',
  '+243',
  '+242',
  '+241',
  '+240',
  '+239',
  '+238',
  '+237',
  '+236',
  '+235',
  '+234',
  '+233',
  '+232',
  '+231',
  '+230',
  '+229',
  '+228',
  '+227',
  '+226',
  '+225',
  '+224',
  '+223',
  '+222',
  '+221',
  '+220',
  '+218',
  '+216',
  '+213',
  '+212',
  '+98',
  '+95',
  '+94',
  '+93',
  '+92',
  '+91',
  '+90',
  '+86',
  '+84',
  '+82',
  '+81',
  '+77',
  '+66',
  '+65',
  '+64',
  '+63',
  '+62',
  '+61',
  '+60',
  '+58',
  '+57',
  '+56',
  '+55',
  '+54',
  '+53',
  '+52',
  '+51',
  '+49',
  '+48',
  '+47',
  '+46',
  '+45',
  '+44',
  '+43',
  '+41',
  '+40',
  '+39',
  '+36',
  '+34',
  '+33',
  '+32',
  '+31',
  '+30',
  '+27',
  '+20',
  '+7',
  '+1',
  '+683',
  '+672',
  '+21',
  '+684',
  '+247',
  '+1441',
  '+1340',
  '+350',
  '+4779',
  '+852',
  '+299',
  '+671',
  '+246',
  '+1345',
  '+853',
  '+596',
  '+258',
  '+1664',
  '+687',
  '+1787',
  '+262',
  '+508',
  '+386',
  '+1670',
  '+886',
  '+690',
  '+500',
  '+594',
  '+689',
  '+590',
  '+969',
  '+1649',
]
